export const projects = [
  {
    name: '10-Plex Professional Center',
    category: 'Commercial Development',
    detail: 'Home to ten independent Southwest Florida businesses.',
    year: '2024',
    image: 'https://cdn.magicpatterns.com/uploads/kcPX5pJ5WdXYmGSSi7WkkT/16170419.jpg',
  },
  {
    name: 'Two-Unit Flex Space',
    category: 'Commercial Development',
    detail: '10,400 sq ft of adaptable warehouse and office space.',
    year: '2023',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e6d952e-0f56-42c0-a5e3-39f45ff0a6d1.jpg',
  },
  {
    name: 'Multipurpose Building',
    category: 'Commercial Development',
    detail: '10,500 sq ft, steel structure with a CastCrete roof system.',
    year: '2022',
    image:
      'https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1000&q=80',
  },
  {
    name: 'Residential Communities',
    category: 'Residential Development',
    detail: 'Two- and three-story homes across Southwest Florida.',
    year: '2006 – Present',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1000&q=80',
  },
  {
    name: 'Site Development',
    category: 'Site Development',
    detail: 'Entitlements, site work and infrastructure for future builds.',
    year: 'Ongoing',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/71c06c81-66bb-463f-9ae7-90e16b868dbc.jpg',
  },
]
